import { defineStore } from "pinia"
import { useStorage } from "@/utils/useStorage.js"

export const useUserStore = defineStore( "UserStore", {

  id: 'user',
  state: () => { 
    return {
      data: useStorage('user-data', {}),
      profile: useStorage('user-profile', {}),
      permissions: useStorage('user-permissions', []),
      token: "",  // Access token lives in memory only; refresh token is in HttpOnly cookie
      _authInitialized: false
    }
  },
  // options
  // getters
  actions: {
    clear() {
      this.data = {}
      this.profile = {}
      this.permissions = []
      this.token = ""
    },
    setToken(token) {
      this.token = token
    },
    setData(data) {
      this.data = data
    },
    setProfile(profile) {
      this.profile = profile
    },
    setProfileField(field, value) {
      this.profile[field] = value
    }
  },
  getters: {
    authenticated() {
      return ( this.token != "" )
    },
    firstName() {
        return this.data.first_name || ""
    },
    lastName() {
        return this.data.last_name || ""
    },
    fullName() {
        return `${this.data.first_name} ${this.data.last_name}`
    }
  }
})
